module.exports = __webpack_public_path__ + "img/bgs.5f20d040.png";